import { useUpdatePWA } from "@/hooks/useUpdatePwa";
import { motion, AnimatePresence } from "framer-motion";

export const PWAUpdatePopUp = () => {
  const { updateAvailable, installUpdate, dismissUpdate } = useUpdatePWA({ autoUpdate: false });
  return (
    <AnimatePresence>
      {updateAvailable && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-4 right-4 bg-white rounded-xl border shadow-xl p-4 max-w-sm w-full"
        >
          <div className=" flex items-center mb-4 gap-x-2">
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2 }}
              className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full "
            >
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </motion.div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Update Available</h2>
          </div>
          <p className="text-gray-600 mb-4 text-sm">A new version of the app is available. Update now to get the latest features and improvements!</p>
          <div className="flex justify-end space-x-2">
            <button
              onClick={dismissUpdate}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Later
            </button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={installUpdate}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Update Now
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
